export default __webpack_public_path__ + "static/media/srisaila-loader.f5e0d999.svg";